import './App.css';
import io from 'socket.io-client';
import { useEffect, useState } from 'react';
import Login from './components/Login';
import Game from './components/Game';
import Lobby from './components/Lobby';
// card imports
import plusTwo from './assets/plusTwo.svg';
import skip from './assets/skip.svg';
import reverse from './assets/reverse.svg';
import cornerPlusTwo from './assets/cornerPlusTwo.svg';
import cornerPlusFour from './assets/cornerPlusFour.svg';
import colors from './assets/colors.svg';
import zero from './assets/zero.svg';
import one from './assets/one.svg';
import two from './assets/two.svg';
import three from './assets/three.svg';
import four from './assets/four.svg';
import five from './assets/five.svg';
import six from './assets/six.svg';
import seven from './assets/seven.svg';
import eight from './assets/eight.svg';
import nine from './assets/nine.svg';
import colorsBlue from './assets/colors_blue.svg';
import colorsRed from './assets/colors_red.svg';
import colorsYellow from './assets/colors_yellow.svg';
import colorsGreen from './assets/colors_green.svg';
import BreakpointMarker from './components/BreakpointMarker';

const imageSources = [
  plusTwo, skip, reverse, cornerPlusTwo, cornerPlusFour, colors,
  zero, one, two, three, four, five, six, seven, eight, nine,
  colorsBlue, colorsRed, colorsYellow, colorsGreen
];

const socket = io.connect(process.env.REACT_APP_SERVER_ADDRESS);

function App() {
  const [connected, setConnected] = useState(false);
  const [playerId, setPlayerId] = useState(null); // if this is set it means the user has joined the room
  const [players, setPlayers] = useState([]);
  const [gamePlayers, setGamePlayers] = useState([]);
  const [complete, setComplete] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [winner, setWinner] = useState('');
  const [gameSettings, setGameSettings] =  useState({});

  const enterRoom = (name, animal) => {
    const userName = name.trim();

    if (userName === '') {
      setLoginError("Fill in username");
      return;
    }

    socket.emit('enter_room', name, animal);
  }

  const startGame = () => {
    // broadcast to everyone (also me) that game is started
    socket.emit('start_game')
  }

  const preloadImages = (sources) => {
    sources.forEach((src) => {
      const img = new Image();
      img.src = src;
    })
  }

  const handleLeave = () => {
    socket.emit('leave_lobby');
    setPlayerId(null);
  }


  useEffect(() => {
    const handleConnect = () => {
      setConnected(true);
    }

    const handleDisconnect = () => {
      setConnected(false);
      setPlayerId(null);
      setPlayers([]);
      setGamePlayers([]);
      setComplete(false);
    }

    const handleUpdatePlayers = (players) => {
      // console.log('all players:', players);
      setPlayers(players);
    }

    const handleJoinRoom = (playerId, gamePlayers) => {
      setPlayerId(playerId);
      setGamePlayers(gamePlayers)
    }

    const handleStartGame = (gamePlayers, settings) => {
      setComplete(false);
      setGamePlayers(gamePlayers);
      setGameSettings(settings);
    }

    const handlePlayerWin = (playerId) => {
      setComplete(true);
      setTimeout(() => {
        setWinner(playerId);
        setGamePlayers([]);
      }, 669);
    }

    const handleStopGame = () => { // server stopped the game
      setGamePlayers([]);
      setComplete(false);
    }

    preloadImages(imageSources);

    socket.on('connect', handleConnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('update_players', handleUpdatePlayers);
    socket.on('join_room', handleJoinRoom);
    socket.on('start_game', handleStartGame);
    socket.on('player_win', handlePlayerWin);
    socket.on('stop_game', handleStopGame);

    return () => {
      socket.off('connect', handleConnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('update_players', handleUpdatePlayers);
      socket.off('join_room', handleJoinRoom);
      socket.off('start_game', handleStartGame);
      socket.off('player_win', handlePlayerWin);
      socket.off('stop_game', handleStopGame);
    }
  }, []);

  return (
    <div className='App text-white h-screen w-screen grid place-items-center'>
      { process.env.REACT_APP_ENV === "development" && (
        <>
          <BreakpointMarker/>
          {/* <div className='z-[500] absolute h-[100px] w-[50vw] bottom-40 left-0 border-r border-pink-500'></div> */}
        </>
      )}
      { !playerId || !connected ? (
          <Login enterRoom={enterRoom} error={loginError} connected={connected}></Login>
        ) :
        (
          <>
            { !gamePlayers.find(p => p.id === playerId) ? ( // if client not in the gamePlayers list
              <Lobby players={players} startGame={startGame} winnerId={winner} playerId={playerId} socket={socket} gameActive={gamePlayers.length > 0} onLeave={handleLeave}></Lobby>
            ) :
            (
              <Game players={gamePlayers} setGamePlayers={setGamePlayers} socket={socket} playerId={playerId} complete={complete} gameSettings={gameSettings}></Game>
            )}
          </>
        )
      }
    </div>
  );
}

export default App;
